import { Dispatch, FC, useEffect, useState } from 'react';
import { Form, Input, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../store';
import { cleanState, passwordRequest } from '../../../store/ducks/auth/actions';
import { Redirect } from 'react-router-dom';
import Swal from 'sweetalert2';
import ContainerBox from '../../../components/ContainerBox';
import { Titulo } from '../style';
import { ArrowLeftOutlined, SwapOutlined } from '@ant-design/icons';

export interface Rules {
  required: boolean;
  message: string;
}

const ForgotPassword: FC<any> = () => {
  const loading = useSelector((state: ApplicationState) => state.auth.passwordLoading);
  const error = useSelector((state: ApplicationState) => state.auth.passwordError);
  const message = useSelector((state: ApplicationState) => state.auth.forgotPasswordMessage);
  const errorMessage = useSelector((state: ApplicationState) => state.auth.errorMessage);
  const [login, setLogin] = useState<boolean>(false);
  const dispatch = useDispatch<Dispatch<Action>>();
  const dispatchClean = useDispatch<Dispatch<Action>>();
  const onFinish = (formData: any) => {
    dispatch(passwordRequest(formData.email));
  };
  const userNameRules: Rules = {
    required: true,
    message: 'Por favor informe um e-mail!',
  };

  useEffect(() => {
    if (loading || (!error && !message)) return;
    Swal.fire({
      title: error ? 'Email inválido!' : 'Email enviado com sucesso!',
      html: '',
      icon: error ? 'error' : 'success',
    });
    dispatchClean(cleanState());
  }, [error, errorMessage, loading, message, dispatchClean]);

  return (
    <ContainerBox>
      <Titulo>
        <SwapOutlined /> Redefinir Senha
      </Titulo>
      <Form name="basic" initialValues={{ remember: true }} onFinish={onFinish}>
        <Form.Item name="email" rules={[userNameRules]}>
          <Input placeholder="Digite seu email" />
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" type="primary" block loading={loading}>
            Enviar email
          </Button>
        </Form.Item>

        <Form.Item>
          <ArrowLeftOutlined />
          <Button
            type="link"
            onClick={() => {
              setLogin(true);
            }}
          >
            Voltar para o login
          </Button>
        </Form.Item>
      </Form>

      {login && <Redirect to="/login" />}
    </ContainerBox>
  );
};

export default ForgotPassword;
